export const AUTH_TOKEN = "auth-token";
export const INDEXED_DB = "shaka_offline_db";
